// extracted by mini-css-extract-plugin
export default {"container":"sqior-chip_container__8IfCM"};